import {
	BenefitItemContentSX,
	BenefitImgContainerSX,
	BenefitItemTitleSX,
	BenefitIDividerSX,
} from '@/components/blocks/ProductDetails/styles/benefits';
import { Box, ButtonBase, Typography, Divider } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import React, { FC, useState } from 'react';
import { DrawerBenefit } from '@/components/blocks/DrawerBenefit';

export const ProductDetailsBenefitsDisplay: FC = () => {
	const [openDrawer, setOpenDrawer] = useState<
		| {
				title: string;
				emsName: string;
		  }
		| undefined
	>(undefined);

	const handleOpenDrawer = (title: string, emsName: string) => () => {
		setOpenDrawer({ title, emsName });
	};

	const handleCloseDrawer = () => {
		setOpenDrawer(undefined);
	};

	return (
		<React.Fragment>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					border: '1px solid #E2E2E2',
					borderRadius: '4px',
					backgroundColor: '#FFFFFF',
					paddingTop: '13px',
					paddingBottom: '13px',
					paddingLeft: '15px',
					paddingRight: '15px',
				}}
			>
				<ButtonBase
					sx={BenefitItemContentSX()}
					onClick={handleOpenDrawer('Cambios y Devoluciones', 'DrawerReturnsExchangesInformative')}
				>
					<Box sx={BenefitImgContainerSX()}>
						<Img src="EmeraldSAS/images/promotion/home/icon_benefits_1_black.svg" height={'25px'} />
					</Box>
					<Box sx={{ width: '80%' }}>
						<Typography sx={BenefitItemTitleSX()}>{'30 días de cambio o devoluciones'}</Typography>
					</Box>
				</ButtonBase>
				<Divider orientation="vertical" flexItem sx={BenefitIDividerSX} />
				<ButtonBase
					sx={BenefitItemContentSX()}
					onClick={handleOpenDrawer('Entregas y Envíos', 'DrawerDeliveriesShipmentsInformative')}
				>
					<Box sx={BenefitImgContainerSX()}>
						<Img src="EmeraldSAS/images/promotion/home/icon_benefits_2_black.svg" height={'24px'} />
					</Box>
					<Box sx={{ width: '80%' }}>
						<Typography sx={BenefitItemTitleSX()}>{'Envío gratis en compras +$999'}</Typography>
					</Box>
				</ButtonBase>
				<Divider orientation="vertical" flexItem sx={BenefitIDividerSX} />
				<ButtonBase
					sx={BenefitItemContentSX()}
					onClick={handleOpenDrawer('Formas de Pago', 'DrawerPaymentMethodsInformative')}
				>
					<Box sx={BenefitImgContainerSX()}>
						<Img src="EmeraldSAS/images/promotion/home/icon_benefits_3_black.svg" height={'20px'} />
					</Box>
					<Box sx={{ width: '80%' }}>
						<Typography sx={BenefitItemTitleSX()}>{'Conoce las formas de pago'}</Typography>
					</Box>
				</ButtonBase>
			</Box>
			<DrawerBenefit
				open={!!openDrawer}
				title={openDrawer?.title || ''}
				emsName={openDrawer?.emsName || ''}
				onClose={handleCloseDrawer}
			/>
		</React.Fragment>
	);
};
